import { classNames } from '@fl/cmsch-fe-library';
import React, { FC, memo, ReactNode } from 'react';
import { Link } from 'react-router';
import styles from './styles.sass';
interface Props {
  /** Logo element rendered in the compact menu. */
  appLogo: ReactNode;
  /** Action icons rendered next to the compact menu logo. */
  actionIcons: ReactNode;
}
const SmallMenuBase: FC<Props> = props => {
  const {
    appLogo,
    actionIcons
  } = props;
  return <div className="position-relative" data-sentry-component="SmallMenuBase" data-sentry-source-file="small-menu.tsx">
            <Link to="/" data-sentry-element="Link" data-sentry-source-file="small-menu.tsx">
                <div className={classNames(styles.smallMenuLogo, 'position-absolute')}>
                    {appLogo}
                </div>
            </Link>
            <div className="d-flex">
                <div className="ml-auto">
                    {actionIcons}
                </div>
            </div>
        </div>;
};

/**
 * Renders the compact shell menu used on smaller breakpoints.
 *
 * @param props Compact shell logo and action icons.
 * @returns The compact menu layout.
 *
 * @example
 * <SmallMenu
 *     appLogo={<span>eskot</span>}
 *     actionIcons={<span />}
 * />
 */
export const SmallMenu = memo(SmallMenuBase);